import ExportTableToCSV from "./exportTableToCSV";
import ExportTableToPDF from "./exportTableToPDF";
import ExportTableToXLSX from "./exportTableToXLSX";
import { ActionGroup } from '../TableActions';

function MillTableExportFunctions({ tableData, headers, projectData }) {
  return (
    <ActionGroup>
      <ExportTableToCSV tableData={tableData.map(row => ({
        id: row.id,
        name: row.name,
        log: row.log_length,
        coeficient: row.coeficient,
        woodType: row.type,
        heightGround: row.height_ground,
        volume: row.volume_m3,
        volumeCoef: row.volume_coef_m3,
        description:row.description
      }))}

        headers={(headers.filter(f => f.Header !== "Type")).map(c => ({ label: c.Header, key: c.id }))?.push({label:"description", id:"description"})} />
      <ExportTableToPDF tableData={tableData.map(row => Object.values({
        id: row.id,
        name: row.name,
        log: row.log_length,
        coeficient: row.coeficient,
        woodType: row.type,
        heightGround: row.height_ground,
        volume: row.volume_m3,
        volumeCoef: row.volume_coef_m3,
        description:row.description
      }))} headers={headers.filter(f => f.Header !== "Type").map(h => (h.Header)).concat("Description")} missionName={projectData.name} missionDate={projectData.cd} title={"Mill mission export"} type={"MillLog"} />
    <ExportTableToXLSX
    tableData={tableData.map(row => ({
      id: row.id,
      name: row.name,
      log: row.log_length,
      coeficient: row.coeficient,
      woodType: row.type,
      heightGround: row.height_ground,
      volume: row.volume_m3,
      volumeCoef: row.volume_coef_m3,
      description:row.description
    }))}

    headers={(headers.filter(f => f.Header !== "Type")).map(c => ({ label: c.Header, key: c.id }))?.push({label:"description", id:"description"})} projectName={projectData.name} />
    </ActionGroup>
  )
}
export default MillTableExportFunctions